import * as React from 'react';
import withStyles from 'react-jss';
import { CssType, ThemeType } from 'src/theme/jss-types';
import { Col, Modal, Row, Table } from 'antd';
import { columnsToShowRouteDetails } from 'src/utils/utils';
import { useTranslation } from 'react-i18next';
import { StylesProps } from 'src/library/types';

const styles = (theme: ThemeType): CssType => ({
    container: {
        padding: '15px 12px',
        margin: '10px 12px',
        backgroundColor: '#ffffff',
        border: '1px solid #D9D9D9',
        borderRadius: '4px',
    },
    divFlex: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
    },
    hint: {
        fontSize: '12px',
        color: '#595959',
        fontWeight: 400,
        margin: '12px 0',
    },
    content: {
        fontSize: '14px',
        color: '#262626',
        fontWeight: 500,
    },
});

interface IProps extends StylesProps<ReturnType<typeof styles>> {
    isVisible: boolean;
    onModalClose: () => void;
    routeDetails: any;
}

const RouteDetailsModal = (props: IProps): React.ReactElement => {
  const { t } = useTranslation();
  const { isVisible, onModalClose, routeDetails, classes } = props;

  const generateColumnForTable = () => {
    const columnData: any = [];
    const indexList = columnsToShowRouteDetails;
    indexList.forEach((item) => {
      const itemToPush = {};
      itemToPush['title'] = t(item.pretty_name);
      itemToPush['dataIndex'] = item.column_id;
      itemToPush['key'] = item.column_id;
      itemToPush['width'] = 80;
      columnData.push(itemToPush);
    });
    return columnData;
  };

  const isValue = (data) => {
    return data ?? 'Not Available';
  };

  function getColumnsToShow(routeData) {
    const columnsToShow = [
      { hint: 'Route Code', content: isValue(routeData.route_code) },
      { hint: 'Origin', content: isValue(routeData.origin_hub_code) },
      { hint: 'Destination', content: isValue(routeData.destination_hub_code) },
      { hint: '#Nodes', content: isValue(routeData.num_nodes) },
      { hint: 'Route', content: isValue(routeData.route_name) },
      { hint: 'Total Km', content: isValue(routeData.total_distance) },
      { hint: 'Total Transit Time', content: isValue(routeData.total_transit_time) },
    ];
    return columnsToShow;
  }

  function renderInfoContainer(hint: any, content: any) {
    const { classes } = props;
    return (
      <Col span={4} className={classes.infoBox}>
        <div className={classes.hint}>{t(hint)}</div>
        <div className={classes.content}>{content}</div>
      </Col>
    );
  }

  const routeData = [
    ...(routeDetails.details ?? []),
  ];

  return (
    <Modal
      title={t('Route Details')}
      width={800}
      visible={isVisible}
      onCancel={onModalClose}
      footer={null}
      destroyOnClose
    >
      <div className={classes.container}>
        {routeDetails ? (
          <Row className={classes.divFlex}>
            {getColumnsToShow(routeDetails).map((i) =>
              renderInfoContainer(i.hint, i.content))}
          </Row>
        ) : null}
      </div>
      {routeDetails && routeData && <Table
        pagination={false}
        scroll={{ y: '400px' }}
        columns={generateColumnForTable()}
        dataSource={routeData}
        rowKey={(record: any) => record['hub_code']}
      />}
    </Modal>
  );
};

export default withStyles(styles)(RouteDetailsModal);
